import { Injectable } from '@angular/core';

import { HttpClient, HttpRequest, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { LanguageService } from '../_services/language.service';

import { Poi, Picture } from '../classes/index';

//import { MapUtils } from '../utils/maputils';

import { TranslateService } from '@ngx-translate/core';

import { Observable, empty } from 'rxjs';
import { map } from 'rxjs/operators';

import { Md5 } from "md5-typescript";

//Wikipedia 
const wikiUrl = "wikipedia.org/w/api.php?origin=*&action=query&generator=geosearch&prop=coordinates|pageprops|pageimages|description|extracts&exintro&explaintext&coprop=type|dim|globe&format=json" //&exsentences=1
//https://en.wikipedia.org/w/api.php?format=json&action=query&list=geosearch&gsradius=2000&gscoord=50.6573691|4.6264117&gslimit=50
//https://fr.wikipedia.org/w/api.php?origin=*&action=query&generator=geosearch&prop=coordinates&format=json&ggscoord=50.6573691|4.6264117&ggsradius=2000&ggslimit=15
//const wikiPageUrl = "wikipedia.org/w/api.php?origin=*&action=opensearch&format=json&search=";
const wikiPageUrl = "wikipedia.org/w/api.php?origin=*&action=query&format=json&prop=extracts&exintro&explaintext&titles=";

//https://fr.wikipedia.org/w/api.php?format=json&action=query&prop=extracts&exintro&explaintext&redirects=1&pageids=5227021

//https://www.wikidata.org/w/api.php?action=wbgetentities&format=xml&props=sitelinks&ids=Q19675&sitefilter=frwiki

//const wikiDataUrl = 'https://www.wikidata.org/w/api.php?origin=*&action=wbgetentities&format=json&props=sitelinks&ids=Q3329331';

//Usin OpenTripMap API
const placesUrl = 'https://api.opentripmap.com/0.1/en/places/radius';
const placesDetailUrl = 'https://api.opentripmap.com/0.1/en/places/xid/';
const placesSuffix = "?apikey=5ae2e3f221c38a28845f05b6cee66e473f8b66c8f5f20aa2d55bfb50&format=json";

//Wikidata
const wikiDataUrl = 'https://www.wikidata.org/wiki/Special:EntityData/';
const wikiImageUrl = 'https://commons.wikimedia.org/w/api.php?origin=https://www.mediawiki.org&action=query&format=json&formatversion=2&prop=imageinfo&iiprop=url&iiurlwidth=320&titles=File:';

const wikiTextUrl = 'https://en.wikipedia.org/w/api.php?origin=*&action=query&format=json&prop=extracts&exintro&explaintext&titles='

//Sygic
const sygicApiKey = 'dBuK7lyT4QV4m8CC084S117JQOSdOfZ2OPN9bkZf';
const sygicUrl = 'https://api.sygictravelapi.com/1.2/en/places';

//http://www.overpass-api.de/api/xapi
@Injectable()
export class PoiService {

	constructor(private http: HttpClient,
		private translate: TranslateService, 
		private languageService: LanguageService,
		private firestore: Firestore) {

		console.log('in PoiService');
	}

	listPoi(cityId){
		return collectionData(query(collection(this.firestore, 'pois'), where('cityId', '==', cityId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let poi = new Poi();
				poi.fromJSON(data);
				return poi;
			});
		}));
	}

	listActivePoi(cityId){
		return collectionData(query(collection(this.firestore, 'pois'), where('cityId', '==', cityId), where('status', '==', 'active')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let poi = new Poi();
				poi.fromJSON(data);
				return poi;
			});
		}));
	}

	listPoiAround(latitude, longitude, radius=100){
		// Create a GeoQuery based on a location
		//return this.geofirestore.collection('cities').near({ center: new firebase.firestore.GeoPoint(latitude, longitude), radius: 1000000 }).get();
		const dY = radius / 111.11;
		const dX = dY / Math.cos(latitude * Math.PI / 180);
		console.log('listPoiAround:'+latitude+','+longitude+','+radius+','+limit+','+dY+','+dX);
		return getDocs(query(collection(this.firestore, 'pois'), 
		where('published','==',true), 
		where('latitude','>=',(latitude-dY)), 
		where('latitude','<=',(latitude+dY)), 
		where('longitude','>=',(longitude-dX)), 
		where('longitude','<=',(longitude+dX)),
		limit(10)));
	}

	listPoiWithCustomPictures(){
		return collectionData(query(collection(this.firestore, 'pois'), where('customPictures', '==', true)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let poi = new Poi();
				poi.fromJSON(data);
				return poi;
			});
		}));
	}

	getPoi(poiUid){
        return docData(doc(this.firestore, 'pois', poiUid), { idField: 'id' })
		.pipe(map((poi:any) => {
			let m = new Poi();
			m.fromJSON(poi);
			return m;
		}));
	}

	addPoi(data) {
		/*if(data.latitude && data.longitude){
			data.coordinates = new firebase.firestore.GeoPoint(data.latitude, data.longitude);
		}*/
		return addDoc(collection(this.firestore, 'pois'), {...data});
	}

	async batchAdd(cityId, poiList){
		// Get a new write batch
		var batch = writeBatch(this.firestore);

		let batchSize = 0;
		for(let poi of poiList){
			if(!poi.id){
				delete poi.icon;
				poi.cityId = cityId;
				poi.status = 'imported';
				/*if(poi.latitude && poi.longitude){
					poi.coordinates = new firebase.firestore.GeoPoint(poi.latitude, poi.longitude);
				}*/
				let poiRef = doc(collection(this.firestore, 'pois'));
				batch.set(poiRef, { ...poi });
				batchSize++;
			}
			if(batchSize>=500){
				await batch.commit();
				batchSize = 0;
				batch = writeBatch(this.firestore);
			}
		}

		// Commit the batch
		if(batchSize>0){
			await batch.commit();
		}
		console.log('batchAdd finished');
	}

	updatePoi(poiUid, data){
		/*if(data.latitude && data.longitude){
			data.coordinates = new firebase.firestore.GeoPoint(data.latitude, data.longitude);
		}*/
		return updateDoc(doc(this.firestore, 'pois', poiUid), data);
	}

	deletePoi(poiId) {
		return deleteDoc(doc(this.firestore, 'pois', poiId));
	}

	listPoiPictures(poiId){
		return collectionData(query(collection(this.firestore, 'pictures'), where('poiId', '==', poiId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let picture = new Picture();
				picture.fromJSON(data);
				return picture;
			});
		}));
	}

	getPicture(picUid){
        return docData(doc(this.firestore, 'pictures', picUid), { idField: 'id' });
	}

	addPicture(picture) {
		return addDoc(collection(this.firestore, 'pictures'), {...picture});
	}

	updatePicture(picUid, data){
		return updateDoc(doc(this.firestore, 'pictures', picUid), data);
	}

	deletePicture(picUid) {
		return deleteDoc(doc(this.firestore, 'pictures', picUid));
	}

	loadPoiSygicAround(lat, lon, radius, limit){
		let headers = new HttpHeaders({'x-api-key': sygicApiKey});

		/*
		Supported categories are: discovering(used for museums, galleries etc.), eating (restaurants), going_out (nightlife), hiking (outdoors), 
		playing (places interesting for families with children), relaxing, shopping, sightseeing, sleeping (accommodation), doing_sports, 
		traveling (transportation).
		 */
		return this.http.get(sygicUrl+`/list?area=${lat},${lon},${radius}&categories=${encodeURIComponent('discovering|playing|sightseeing')}&limit=${limit}`, {headers: headers})
		.pipe(map((response: any) => {
			console.log('Got response from sygic:'+response);
			/*if(response && response.length>0){
				console.log("EL:"+JSON.stringify(response[0]))
			}*/
			let poiList = [];
			if(response && response.data && response.data.places){
				for(let el of response.data.places){
					console.log("SYGIC_EL:"+JSON.stringify(el));
					let poi = new Poi();
					//console.log("Found title:"+pages[key].title);
					//console.log("Found extract:"+pages[key].extract);
					poi.origin = 'sygic';
					poi.extid = 'sygic_'+el.id;
					//poi.id = el.id;
					poi.xid = el.id;
					poi.name = el.name;
					poi.label = el.name;
					poi.rating = el.rating;
					poi.latitude = el.location.lat;
					poi.longitude = el.location.lng;
	
					poi.thumbUrl = el.thumbnail_url;
		
					poiList.push(poi);
				}
			}
			return poiList;
		}));
	}

	loadPoiAround(lat, lon, radius, kinds, limit): Observable<any> {
		console.log('loadPoiAround:'+placesUrl+placesSuffix+`&lat=${lat}&lon=${lon}&radius=${radius}&limit=${limit}&kinds=${kinds}`);
		//rate: Minimum rating of the object popularity, 1 - minimum, 3- maximum, h - object is referred to the cultural heritage. 2 (all named objects) is default.
		//available values : 1, 2, 3, 1h, 2h, 3h

		return this.http.get(placesUrl+placesSuffix+`&lat=${lat}&lon=${lon}&radius=${radius}&limit=${limit}&kinds=${kinds}`) //&rate=3 //&kinds=interesting_places
		.pipe(map((response: any) => {
			console.log('Got response from opentripmap:'+response);
			if(response && response.length>0){
				console.log('Got response from opentripmap:'+response.length);
				/*if(response && response.length>0){
					console.log("EL:"+JSON.stringify(response[0]))
				}*/
				let poiList = [];
				for(let el of response){
					//console.log("EL:"+JSON.stringify(el));
					if(el.name && el.name.length>0){
						//console.log("EL:"+JSON.stringify(el));
						let poi = new Poi();
						//console.log("Found title:"+pages[key].title);
						//console.log("Found extract:"+pages[key].extract);
						poi.origin = 'otm';
						//poi.extid = 'otm_'+el.xid;
						//poi.id = el.xid;
						poi.xid = el.xid;
						poi.name['en'] = el.name;
						//poi.label = el.name;
						if(el.wikidata){
							poi.wikidata = el.wikidata;
						}
						poi.rating = el.rate;
						poi.latitude = el.point.lat;
						poi.longitude = el.point.lon;
						poi.kinds = el.kinds;
		
						//poi.distance = el.dist;
			
						poiList.push(poi);
					}
					else if(el.name && el.name.length>0){
						console.log("OTM POI without wikidata:"+JSON.stringify(el));
					}
				}
				return poiList.sort((a, b) => {
					if (a.rating > b.rating) return -1;
					else if (a.rating < b.rating) return 1;
					else return 0;
				});
			}
			return [];
		}));
	}

	getPoiDetail(poi){
		if(poi.origin == 'otm'){
			console.log('Load details:'+placesDetailUrl+poi.xid+placesSuffix);
			return this.http.get(placesDetailUrl+poi.xid+placesSuffix)
			.pipe(map((response: any) => {
				//console.log('Got response:'+JSON.stringify(response));
				if(response){
					if(response.preview){
						poi.thumbUrl = response.preview.source;
					}
					poi.imageUrl = response.image;
					//poi.description = pages[key].description;
					if(response.wikipedia_extracts){
						poi.wikitext = response.wikipedia_extracts.html;
					}
				}
			}));
		}
		else if(poi.origin == 'sygic'){
			let headers = new HttpHeaders({'x-api-key': sygicApiKey});
			return this.http.get(sygicUrl+'/'+poi.xid, {headers: headers})
			.pipe(map((response: any) => {
				console.log('Got response from sygic:'+JSON.stringify(response));
				if(response && response.data && response.data.place){
					if(response.data.place.description){
						poi.description = response.data.place.description.text;
					}
				}
			}));
		}
		return empty()
	}

	loadWikiAround(lat, lon, radius, limit): Observable<any> {
		//colimit=number of results we should add coordinates to
		console.log(`https://${this.translate.currentLang}.${wikiUrl}&ggscoord=${lat}|${lon}&ggslimit=${limit}&ggsradius=${radius}&colimit=${limit}&type=railwaystation_landmark`);
		return this.http.get(`https://${this.translate.currentLang}.${wikiUrl}&ggscoord=${lat}|${lon}&ggslimit=${limit}&ggsradius=${radius}&colimit=${limit}&type=railwaystation_landmark`)
		.pipe(map((response: any) => {
			//console.log('Got response from wikipedia:'+response);

			let poiList = [];

			if(response && response.query && response.query.pages){
				const pages = response.query.pages;
				//console.log('PAGES:'+JSON.stringify(pages));
				for(var key in pages) {
					//console.log("EL:"+JSON.stringify(pages[key]));
					//console.log('Check page key '+key);
					if(pages.hasOwnProperty(key) && pages[key].coordinates 
							&& pages[key].coordinates[0].type !== 'city'
							&& pages[key].thumbnail) {
						//console.log('Key found');
						let poi = new Poi();
						if(pages[key].coordinates[0].type){
							poi.type = pages[key].coordinates[0].type;
						}
						//console.log("Found title:"+pages[key].title);
						//console.log("Found extract:"+pages[key].extract);
						if(pages[key].pageprops && pages[key].pageprops.wikibase_item){
							poi.wikidata = pages[key].pageprops.wikibase_item;
						}
						poi.origin = 'wiki';
						//poi.extid = 'wiki_'+key;
						//poi.id = key;
						poi.name[this.translate.currentLang] = pages[key].title;
						//poi.label = pages[key].title;
						//poi.description = pages[key].description;
						//poi.wikitext = pages[key].extract;
						poi.latitude = pages[key].coordinates[0].lat;
						poi.longitude = pages[key].coordinates[0].lon;
						poi.thumbUrl = pages[key].thumbnail.source;
						let url = poi.thumbUrl.substring(0, poi.thumbUrl.lastIndexOf('/'));
						//console.log('Image url1:'+url);
						poi.thumbUrl = url.replace('/thumb','');

						//Distance
		  				//poi.distance = Math.round(MapUtils.calcDistance(lat, lon, poi.latitude, poi.longitude));
		  
						poiList.push(poi);
					}
				}
			}
			
			return poiList.sort((a, b) => {
				if (a.distance > b.distance) return 1;
				else if (a.distance < b.distance) return -1;
				else return 0;
			});
		}));
	}

	loadWikiData(poi){
		if(!poi.wikidata){
			console.log('No wikidata to load');
			return empty();
		}
		console.log('Get wikidata at url:'+wikiDataUrl+`${poi.wikidata}.json`);
		return this.http.get(wikiDataUrl+`${poi.wikidata}.json`)
		.pipe(map((wikires: any) => {
			if(wikires.entities && wikires.entities[poi.wikidata]){
				//console.log('Found entity')
				const res = wikires.entities[poi.wikidata];
				//console.log('Found entity:'+JSON.stringify(res));
				poi.labels = res.labels;
				poi.descriptions = res.descriptions;
				
				poi.name = {};
				poi.description = {};
				poi.sitelinks = {};
				for(let code of this.languageService.languagesCodes){
					if(res.labels[code]){
						poi.name[code] = res.labels[code].value;
					}
					if(res.descriptions[code]){
						poi.description[code] = res.descriptions[code].value;
					}
					if(res.sitelinks[code+'wiki']){
						poi.sitelinks[code] = res.sitelinks[code+'wiki'];
					}
				}
				//image = P18
				//The final image URL will be: https://upload.wikimedia.org/wikipedia/commons/a/ab/img_name.ext, where a and b are the first and the second chars of md5sum of the img_name.ext.
	
				if(res.claims && res.claims['P18']){
					//this.getWikiImageUrl(poi, res.claims['P18'][0].mainsnak.datavalue.value);
					const imgName = res.claims['P18'][0].mainsnak.datavalue.value.replace(/ /g,'_');
					console.log('Image name is:'+imgName);
					//const md5 = Md5Helper.calcMd5(imgName);
					const md5 = Md5.init(imgName);
					//console.log('Image md5:'+md5);
					const md5_1 = md5.substring(0,1);
					//console.log('Image md5_1:'+md5_1);
					const md5_2 = md5.substring(1,2);
					//console.log('Image md5_2:'+md5_2);
					const url = `https://upload.wikimedia.org/wikipedia/commons/${md5_1}/${md5_1}${md5_2}/${imgName}`;
					//console.log('Image url:'+url);
					poi.imageUrl = url;
					if(!(imgName.indexOf('.svg')>-1))
						poi.thumbUrl = `https://upload.wikimedia.org/wikipedia/commons/thumb/${md5_1}/${md5_1}${md5_2}/${imgName}/320px-${imgName}`;
					else
						poi.thumbUrl = poi.imageUrl;
				}
				else{
					poi.hidden = true;
				}

				if(res.claims && res.claims['P361']){
					//P361 - POI is part of another one
					//console.log('POI '+poi.label+' is part of another one, make it hidden');
					poi.hidden = true;
				}
			}
		}));
	}

	getSiteLinks(poi){
		if(!poi.wikidata){
			console.log('No wikidata to load');
			return empty();
		}
		console.log('Get wikidata at url:'+wikiDataUrl+`${poi.wikidata}.json`);
		return this.http.get(wikiDataUrl+`${poi.wikidata}.json`)
		.pipe(map(async (wikires: any) => {
			if(wikires.entities && wikires.entities[poi.wikidata]){
				//console.log('Found entity')
				const res = wikires.entities[poi.wikidata];
				poi.sitelinks = {};
				for(let code of this.languageService.languagesCodes){
					if(res.sitelinks[code+'wiki']){
						poi.sitelinks[code] = res.sitelinks[code+'wiki'];
					}
				}
				if(poi.id && Object.keys(poi.sitelinks).length > 0){
					console.log('Update POI '+poi.id+'with sitelinks values:'+JSON.stringify(poi.sitelinks));
					await this.updatePoi(poi.id, {sitelinks: poi.sitelinks});
				}
			}
			console.log('Updated sitelinks:'+JSON.stringify(poi.sitelinks));
		}));
	}

	getWikiImageUrl(poi, name){
		//console.log('getWikiImageUrl:'+encodeURI(wikiImageUrl+name));
		this.http.get(encodeURI(wikiImageUrl+name))
		.pipe(map((response: any) => response))
		//.catch((error:any) => observableThrowError(error || 'Server error'))
		.subscribe(imageRes => {
			//console.log('getWikiImageUrl returns:'+imageRes);
			if(imageRes && imageRes.query && imageRes.query.pages && imageRes.query.pages[0]){
				const image = imageRes.query.pages[0];
				//console.log('Found image, thumbUrl='+image.imageinfo[0].thumburl);
				//console.log('Found image, url='+image.imageinfo[0].url);
				poi.imageUrl = image.imageinfo[0].url;
				poi.thumbUrl = image.imageinfo[0].thumburl;
			}
		}, (e) => {
			console.log('Server error:'+JSON.stringify(e));
		});
	}

	getWikiExtracts(poi, lang){
		const restUrl = `https://${lang}.${wikiPageUrl}${poi.sitelinks[lang].title}`;
		return this.http.get(restUrl)
		.pipe(map((res:any) => {
			//console.log('getWikiPage details:'+JSON.stringify(res));
			if(res && res.query && res.query.pages){
				for(var key in res.query.pages) {
					if(res.query.pages.hasOwnProperty(key)) {
						//console.log("Found extract:"+res.query.pages[key].extract);
						poi.extracts[lang] = res.query.pages[key].extract;
					}
				}
			}
		}));
	}

	getPlacesPictureUrl(poi){
		const restUrl = `https://maps.googleapis.com/maps/api/place/details/json?placeid=${poi.placeId}&key=AIzaSyCzC1yvO6W4Xw-C2ZUjEkjQ89kzqmxVfxo`;
		return this.http.get(restUrl)
		.pipe(map((json:any) => {
			//console.log('getWikiPage details:'+JSON.stringify(res));
			if(json.data && json.data.result && json.data.result.photos && json.data.result.photos.length>0){
				let photoReference = json.data.result.photos[0].photo_reference;
				console.log('photoReference:'+photoReference);
				poi.thumbUrl = `https://maps.googleapis.com/maps/api/place/photo?photoreference=${photoReference}&sensor=false&maxheight=400&maxwidth=800&key=AIzaSyCzC1yvO6W4Xw-C2ZUjEkjQ89kzqmxVfxo`;
      			poi.imageUrl = `https://maps.googleapis.com/maps/api/place/photo?photoreference=${photoReference}&sensor=false&maxheight=400&maxwidth=800&key=AIzaSyCzC1yvO6W4Xw-C2ZUjEkjQ89kzqmxVfxo`;
			}
		}));
	}


}
